import React from 'react';
import {arrayOf, bool, func, object, oneOf, string} from 'prop-types';
import {Grid} from 'semantic-ui-react';
import {DropTarget} from 'react-dnd';
import values from 'lodash/values';
import partial from 'lodash/partial';
import PlatformStep from './PlatformStep';
import SortableStepTypes from './SortableStepTypes';
import {isNoU} from "../../utils/DBUtils";

const stepTarget = {
  // steps can only swap positions with each other; they cannot be dropped on the
  // containing column itself.
  drop() {}
};

const getInfo = (step, masterSteps) => {
    let order = step.displayOrder;
    let internalLabel = step.internalLabel;
    let masterStep = masterSteps.find(masterStep => masterStep.id === step.id);
    if (isNoU(order)) {
        order = masterStep.displayOrder;
    }
    if (isNoU(internalLabel)) {
      if (masterStep) {
        internalLabel = masterStep.internalLabel;
      }
    }
    return {order, internalLabel};
};

const PlatformColumn = ({
  masterSteps = [],
  steps = [],
  challengeId,
  sortable = false,
  itemType,
  platformKey,
  platformName,
  togglePublishStep,
  connectDropTarget,
  findStep,
  moveStep
}) => {
  let displaySteps = steps.slice().map((step) => {
      let {order, internalLabel} = getInfo(step, masterSteps);
      return {
          ...step,
          displayOrder: order,
          internalLabel
      };
  });

  // A platform must keep at least one enabled step, so the toggle on the last
  // enabled step is locked (BR-5703).
  const enabledStepCount = displaySteps.filter(step => step.synchronized && step.publishStep).length;

  const column = (
    <div>
      {displaySteps.map(step => (
          <Grid.Row key={step.id}>
            <PlatformStep
              id={step.id}
              challengeId={challengeId}
              sortable={sortable}
              itemType={itemType}
              platformKey={platformKey}
              platformName={platformName}
              label={step.internalLabel}
              stepType={step.type}
              synchronized={step.synchronized}
              publishStep={step.publishStep}
              isLastEnabledStep={step.publishStep && enabledStepCount <= 1}
              onChange={partial(togglePublishStep, step.resourceId)}
              findStep={findStep}
              moveStep={moveStep} />
          </Grid.Row>
        ))}
    </div>
  );

  return sortable ? connectDropTarget(column) : column;
};

PlatformColumn.propTypes = {
  steps: arrayOf(object),
  sortable: bool,
  itemType: oneOf(values(SortableStepTypes)).isRequired,
  platformKey: string.isRequired,
  platformName: string.isRequired,
  togglePublishStep: func.isRequired,
  connectDropTarget: func.isRequired,
  findStep: func.isRequired,
  moveStep: func.isRequired
};

export default DropTarget(props => props.itemType, stepTarget, connect => ({
  connectDropTarget: connect.dropTarget()
}))(PlatformColumn);



// WEBPACK FOOTER //
// ./public/pages/ViewAllPlatforms/PlatformColumn.jsx